import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Features from "./pages/Features";
import Contact from "./pages/Contact";
import Distributors from "./pages/Distributors";
import Mixology from "./pages/Mixology";

function App() {
  return (
    <BrowserRouter>
      <div style={{ background: '#0A0A0A', minHeight: '100vh' }}>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/caracteristicas" element={<Features />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/distribuidores" element={<Distributors />} />
          <Route path="/mixologia" element={<Mixology />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
